import { dateMask } from 'services/utils/inputMasks';

import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

/**
 * Mascara para input de valores inteiros
 *
 * @param {object} props
 */
export const InputIntegerMask = ({ ...props }) => {
  return (
    <MaskedInput
      {...props}
      mask={createNumberMask({
        prefix: '',
        allowDecimal: false,
        allowNegative: true,
        thousandsSeparatorSymbol: '',
      })}
      placeholder="999"
    />
  );
};

/**
 * Mascara para input de valores decimais
 *
 * @param {object} props
 */
export const InputDecimalMask = ({ ...props }) => {
  return (
    <MaskedInput
      {...props}
      mask={createNumberMask({
        prefix: '',
        allowDecimal: true,
        decimalSymbol: ',',
        thousandsSeparatorSymbol: '.',
        decimalLimit: 5,
        allowNegative: true,
      })}
      placeholder="999,999"
    />
  );
};

/**
 * Mascara para input de valores data
 *
 * @param {object} props
 */
export const InputDateMask = ({ ...props }) => {
  return (
    <MaskedInput
      {...props}
      mask={dateMask()}
      guide={false}
      placeholderChar={'\u2000'}
      showMask
      placeholder="dd/mm/aaaa"
    />
  );
};
